export enum Status {
  ACCEPTED = "ACCEPTED",
  PASSED = "PASSED",
  WAITING = "WAITING",
  NONE = "NONE",
}

export enum Defense {
  RANGE = "RANGE",
  RANK = "RANK",
  NONE = "NONE",
}

export enum Display {
  ELAPSED_TIME = 'elapsed',
  LAST_TIME = 'last',
}

export type User =  {
  handle: string
  rating: number
  topRating: number
  problemId: number
  problemName: string
  problemLevel: number
  defense: Defense
  status: Status
  updatedAt: Date
}

export type Log = {
  id: string
  handle: string
  problemId: number
  problemName: string
  problemLevel: number
  rating: number
  defense: Defense
  status: Status
  elapsedTime: string
  createdAt: Date
}

export type LogLastEvaluatedKey = {
  handle: string,
  'problemId#status': string
}